import { Link } from "gatsby"
import React from "react"

function NavLink(props) {
  return <Link activeClassName="active" {...props} />
}

export default NavLink
